import * as tslib_1 from "tslib";
const decodeJWT = (str) => {
    const base64Url = str.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64)
        .split('')
        .map((c) => ('%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)))
        .join(''));
    return JSON.parse(jsonPayload);
};
const stringToUrlFriendly = (str) => {
    // Normalize the string to handle accents
    const normalizedStr = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    // Remove special characters using regular expressions
    const urlFriendlyStr = normalizedStr.replace(/[^a-zA-Z0-9]/g, "-");
    // Convert to lowercase and trim extra dashes
    return urlFriendlyStr.toLowerCase().replace(/-+/g, "-").replace(/^-|-$/g, "");
};
export { decodeJWT, stringToUrlFriendly };
//# sourceMappingURL=strings.js.map